export const darkTheme = {
  palette: {
    brand: {
      bump: '#77c81d',
      vip: '#ff3d00',
      premium: '#ff9f2b',
      main: '#ca1016'
    },
    text: {
      main: '#212c3a',
      secondary: '#8d94ad',
      tertiary: '#b1b8c6',
      quaternary: '#f9f9f9'
    },
    bg: {
      main: '#ffffff',
      secondary: '#f6f7fa',
      tertiary: '#ffeea5',
      quaternary: '#f6f7fa',
      filters: '#fafbff'
    },
    system: {
      blue: '#4c88f9',
      deepBlue: '#4264fd',
      lightBlue: '#dae8ff',
      green: '#3db460',
      red: '#ff586d',
      yellow: '#ffb900',
      white: '#ffffff',
      black: '#1a1a1a',
      'red-to-white': '#fdecf4'
    },
    border: {
      main: '#eaebf2',
      secondary: '#f1f3f7',
      tertiary: '#dfe3e9'
    },
    borderRadius: {
      main: '14px',
      large: '22px'
    },
    hover: {
      blue: '#3273ec'
    },
    custom: {
      grey: '#f8f4f1',
      'red-bg': '#ffe6e5'
    }
  }
};
